/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from "react";
import { Row, Popover } from "antd";
import {
  InfoCircleOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";

const IndeksKarakterGrafikCard = ({ title, info, data, icon = null }) => {
  return (
    <div
      style={{
        color: "#1B6FBA",
        backgroundColor: "#fff",
        borderRadius: 24,
        border: "2px solid #1B6FBA",
      }}
    >
      <Row
        justify="space-between"
        align="middle"
        style={{
          padding: 12,
        }}
      >
        <div
          className="text-default"
          style={{
            fontSize: 24,
          }}
        >
          {title}
        </div>
        <Popover content={<h3>{info}</h3>}>
          <InfoCircleOutlined
            style={{
              fontSize: 24,
            }}
          />
        </Popover>
      </Row>

      <div className="text-header" style={{ paddingLeft: 12, fontSize: 40 }}>
        {data}
        &nbsp;
        {icon !== null ? (
          icon ? (
            <ArrowUpOutlined
              style={{
                fontWeight: 700,
                color: "#2CF6E5",
              }}
            />
          ) : (
            <ArrowDownOutlined
              style={{
                fontWeight: 700,
                color: "#FF859C",
              }}
            />
          )
        ) : null}
      </div>

      <img
        src={`${process.env.PUBLIC_URL}/assets/ilustrasi-grafik.png`}
        alt="Grafik"
        style={{
          maxWidth: "100%",
          width: "100%",
          height: "auto",
          objectFit: "fill",
        }}
      />
    </div>
  );
};

export default IndeksKarakterGrafikCard;
